// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Torw","tab":"ProcedureTabs_tab__2S5kC"};